import { matchPath } from 'react-router-dom';

import { config } from 'ENV_CONFIG';

export const getEditRoutePathParams = (pathname) =>
  matchPath(pathname, { path: '/:appointmentId([0-9]+)' }) || { params: {} };

export const isEditAppointmentPage = (pathname) =>
  !!matchPath(pathname, {
    path: config.editAppointmentPaths,
  });
